<template>
    <section class="bg-black">
      <div>
        <div class="grid items-center grid-cols-12 lg:gap-x-16 gap-y-8">
          <!-- Left Content -->
          <div
            class="lg:col-span-7 max-w-3xl mx-auto col-span-12 lg:pl-4 xl:pl-0 xl:mr-16 lg:pb-0 pb-8 lg:px-0 px-4 lg:order-1 order-2 xl:pl-4 lg:ml-[calc((100vw_-_1024px)_/_2)]"
          >
            <div
              class="text-xl font-bold text-center text-white font-ww-bold sm:text-xl md:text-2xl xl:text-28 lg:text-left"
              v-html="title"
            ></div>
  
            <div class="grid mt-6 gap-y-6">
              <div
                v-for="(guarantee, index) in guarantees"
                :key="index"
                class="flex gap-x-4"
              >
                <div class="w-10 lg:w-12">
                  <nuxt-img
                    :src="guarantee.imgSrc"
                    :alt="guarantee.alt"
                    sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1400px"
                    loading="lazy"
                    format="webp"
                    width="46"
                    height="48"
                    class="w-full"
                  />
                </div>
                <div class="w-full">
                  <div class="text-base text-left text-white font-ww-bold xl:text-xl">
                    {{ guarantee.title }}
                    <span
                      v-if="guarantee.isNew"
                      class="bg-[#F1594B] uppercase px-2 text-xs md:text-sm font-ww-bold ml-2"
                    >
                      new
                    </span>
                  </div>
                  <div class="text-base text-left text-white font-ww-light xl:text-lg !leading-7">
                    {{ guarantee.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Right Image -->
          <div class="order-1 col-span-12 lg:col-span-5 lg:order-2">
            <nuxt-img
              :src="rightImageSrc"
              :alt="rightImageAlt"
              class="w-full max-w-xl mx-auto lg:max-w-screen-md"
              sizes="xs:330px sm:440px md:760px lg:1024px xl:576px 2xl:455px"
              loading="lazy"
              format="webp"
              width="562"
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    title: {
      type: String,
      default: 'Our Love Your Coffee Triple-Protection Guarantee:',
    },
    guarantees: {
      type: Array,
      default: () => [
        {
          imgSrc: '/assets/images/number-1.png',
          alt: 'Price Lock Guarantee',
          title: 'Price Lock Guarantee',
          description: "Your subscription price won't increase for 12 months - period.",
          isNew: false,
        },
        {
          imgSrc: '/assets/images/number-2.png',
          alt: 'Satisfaction Guarantee',
          title: 'Satisfaction Guarantee',
          description: 'Love your coffee or get your money back.',
          isNew: false,
        },
        {
          imgSrc: '/assets/images/number-3.png',
          alt: 'Expedited Shipping',
          title: 'Expedited Shipping',
          description:
            'Every bag is Small Batch roasted to order and for the first time ever, you receive expedited shipping by being on subscription.',
          isNew: true,
        },
      ],
    },
    rightImageSrc: {
      type: String,
      default: '/assets/images/right-img-big.png',
    },
    rightImageAlt: {
      type: String,
      default: 'Guarantee image',
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'FeatureWithIconsAndImage',
    inputs: [
      {
        name: 'title',
        type: 'richText',
        friendlyName: 'Section Title',
        defaultValue: 'Our Love Your Coffee Triple-Protection Guarantee:',
      },
      {
        name: 'guarantees',
        type: 'list',
        friendlyName: 'Guarantees List',
        subFields: [
          {
            name: 'imgSrc',
            type: 'file',
            friendlyName: 'Guarantee Image Source',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
          },
          {
            name: 'alt',
            type: 'text',
            friendlyName: 'Guarantee Image Alt Text',
          },
          {
            name: 'title',
            type: 'text',
            friendlyName: 'Guarantee Title',
          },
          {
            name: 'description',
            type: 'text',
            friendlyName: 'Guarantee Description',
          },
          {
            name: 'isNew',
            type: 'boolean',
            friendlyName: 'Is New Badge',
            defaultValue: false,
          },
        ],
        defaultValue: [
          {
            imgSrc: '/assets/images/number-1.png',
            alt: 'Price Lock Guarantee',
            title: 'Price Lock Guarantee',
            description: "Your subscription price won't increase for 12 months - period.",
            isNew: false,
          },
          {
            imgSrc: '/assets/images/number-2.png',
            alt: 'Satisfaction Guarantee',
            title: 'Satisfaction Guarantee',
            description: 'Love your coffee or get your money back.',
            isNew: false,
          },
          {
            imgSrc: '/assets/images/number-3.png',
            alt: 'Expedited Shipping',
            title: 'Expedited Shipping',
            description:
              'Every bag is Small Batch roasted to order and for the first time ever, you receive expedited shipping by being on subscription.',
            isNew: true,
          },
        ],
      },
      {
        name: 'rightImageSrc',
        type: 'file',
        friendlyName: 'Right Image Source',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        defaultValue: '/assets/images/right-img-big.png',
      },
      {
        name: 'rightImageAlt',
        type: 'text',
        friendlyName: 'Right Image Alt Text',
        defaultValue: 'Guarantee image',
      },
    ],
  });
  </script>
  